import React, {useEffect, useState} from "react";
import {UseContext} from "../context";
import {useContext} from "react";
import {Navigate, useNavigate} from "react-router-dom";
import "./Scroll.css";
import Loadingcom from "./allcomponent/Loading";
import {url} from "../url";
import axios from "axios";
import Loading from "./allcomponent/Loading";
import { MdChat as ChatIcon } from 'react-icons/md';
import PendingApprovalScreen from "./allcomponent/PendingApproval";


const Reportcom = () => {

    const navigate = useNavigate();

    const {
        showmessagecom,
        getmyprof,
        getprofloading,
        setShowmessagecom,
        showexit,
        showreportcom,
        setAllactivetravel,
        allactivetravel,
    } = useContext(UseContext);

    const [errortravel, setErrortravel] = useState("");

    const [loading, setLoading] = useState(false);

    const handleshowmessagecom = (item) => {
        navigate("/report/Message", {state: item});
        setShowmessagecom(true);
    };


    useEffect(() => {
        setLoading(true)
        axios
            .get(`${url}/travel/v1/get-active-travel-driver`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            .then((res) => {
                if (res.status === 200) {
                    setAllactivetravel(res.data.data);
                }
                setLoading(false)
            })
            .catch((error) => {
                console.log('report api error : ', error);
                setLoading(false)
                if (error.response) {
                    setErrortravel(error.response.data.message);
                }
            });
    }, [setAllactivetravel]);

    return (
        <>
            {localStorage.getItem("token") !== null ? (
                <>
                    {getprofloading === false ? (
                        <>
                            {getmyprof.status === "profile_not_completed" ? (
                                <Navigate to="/UserandCarinformation"/>
                            ) : (
                                <>
                                    {getmyprof.status === "pending" ? (
                                        <div
                                            className="w-full flex flex-col h-full  overflow-auto mb-[100px] lg:mb-[88px]">
                                            <PendingApprovalScreen />
                                        </div>
                                    ) : (
                                        <>
                                            {showmessagecom === false && (
                                                <div
                                                    id="reportdiv"
                                                    className="w-full h-full  overflow-auto "
                                                >
                                                    <div className="pr-4 mt-3 flex cursor-pointer items-center gap-x-2">
                                                        <ChatIcon className="text-amber-400 text-[26px]"/>
                                                        <p className="text-[24px] font-medium">مکالمات با مسافران</p>
                                                    </div>
                                                    {showreportcom && (
                                                        <div>
                                                            {!loading ?
                                                                (
                                                                    <>
                                                                        {Object.keys(allactivetravel).length !== 0 ? (
                                                                            <div
                                                                                className="ml-4 mr-4 "
                                                                                onClick={
                                                                                    showexit === false
                                                                                        ? () =>
                                                                                            handleshowmessagecom(
                                                                                                allactivetravel
                                                                                            )
                                                                                        : null
                                                                                }
                                                                            >
                                                                                <div>

                                                                                    <div
                                                                                        className={`w-full text-colorplaceholder text-[20px] bg-whitecolor mt-4 gap-3 rounded-[10px] flex justify-center items-center border-[1px] border-black p-7 ${
                                                                                            showexit === false
                                                                                                ? "cursor-pointer"
                                                                                                : ""
                                                                                        }`}
                                                                                    >
                                                                                        <div className='flex gap-1'>
                                                                                            <p className="text-center  font-normal   ">
                                                                                                سفر
                                                                                            </p>
                                                                                            <p className=" font-normal">
                                                                                                {allactivetravel.origin_city?.name}
                                                                                            </p>
                                                                                            <p className=" font-normal">به</p>
                                                                                            <p className=" font-normal ">
                                                                                                {
                                                                                                    allactivetravel.destination_city
                                                                                                        ?.name
                                                                                                }
                                                                                            </p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <div
                                                                                className=" h-[90vh] w-full flex flex-col  items-center justify-center ">
                                                                                <>
                                                                                    <div
                                                                                        id="reportdiv"
                                                                                        className=" flex  items-center justify-center  "
                                                                                    >
                                                                                        <p className="text-[20px] text-center  text-[black] font-bold">
                                                                                            {errortravel}
                                                                                        </p>
                                                                                    </div>
                                                                                </>
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <div
                                                                        className='h-[90vh] flex justify-center items-center'>
                                                                        <Loading/>
                                                                    </div>
                                                                )}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <div className=" h-full w-full flex flex-col   items-center justify-center ">
                            <>
                                <div
                                    id="reportdiv"
                                    className=" flex  items-center justify-center  "
                                >
                                    <p className="text-[20px] text-center  text-[black] font-bold">
                                        در انتظار دریافت اطلاعات ...
                                    </p>
                                </div>
                            </>
                        </div>
                    )}
                </>
            ) : (
                navigate("/")
            )}
        </>
    );
};
export default Reportcom;
